/* eslint-disable */
import React, { useState } from "react";
import { Avatar, Menu, Text, Input, CloseButton, Select } from "@mantine/core";
import { useSelector, useDispatch } from "react-redux";
import { AiOutlineSearch } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import styles from "./AppHeader.module.css";
import { assetsPrefix } from "../../utilities/utilities";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import { selectUserData } from "../../redux/selectors";
import { DoorExit, Lock, Exchange } from "tabler-icons-react";
import {
  deleteCookie,
  getCookiesSession,
  setCookiesSession,
} from "../../cookiesSession";
import { changeUserRole } from "../../utilities/apis/users";
import actions from "../../redux/actions";
import constants from "../../utilities/constants";

const AppHeader = () => {
  const userData = useSelector(selectUserData);
  const [opened, setOpened] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hideLogo = location.pathname === "/app/choose_manager";
  const currentUser = useSelector(selectUserData) || {};
  const loginAs = currentUser?.loginAs ?? null;
  const roles = currentUser?.userRole ?? [];

  const logoutHandler = () => {
    if (getCookiesSession("LawSignaUserDataMaster")) {
      deleteCookie("LawSignaUserDataMaster");
      deleteCookie("masterResult");
    }
    window.location = process.env.REACT_APP_LANDING_PAGE_URL;
  };

  const handleRoleChange = async (value) => {
    if (!value) return;
    try {
      let resp = await apiWrapWithErrorWithData(changeUserRole(value));
      // console.log(resp);
      if (resp?.success && resp?.result) {
        resp = resp.result;
        setCookiesSession("LawSignaUserDataMaster", JSON.stringify(resp), 2);
        dispatch({
          type: actions.SET_USER_DATA,
          payload: resp.user,
        });
        navigate(0);
      }
      // Reload the page
    } catch (error) {
      console.error("Error while switching roles:", error);
      // Handle error if needed
    }
  };

  return (
    <div className="flex flex-row items-center justify-between mx-8 my-2 mt-0">
      {/* Grouping Logo and Badge together solves the alignment & line spacing */}
      <div className="flex items-center">
        <img
          className={styles.logo}
          src={`${assetsPrefix}/images/SecondaryLogo.png`}
          alt="LawSigna"
        />
        <Text
          style={{
            marginLeft: "12px", // Slightly increased to clear the logo elegantly
            padding: "3px 10px",
            borderRadius: "999px",
            border: "1px solid #d1d5db",
            backgroundColor: "#edeeef",
            fontSize: "0.80rem",
            fontWeight: 600,
            fontFamily: "Cinzel",
            textTransform: "none",
            visibility: hideLogo ? "hidden" : "visible",
          }}
        >
          Receivables Engine
        </Text>
      </div>

      {/* Right container: Dropdown Select + User Profile Menu */}
      <div className="flex items-center">
        <Select
          required
          className="max-w-lg mr-4" // Adjusted margin-right slightly for better spacing
          placeholder="Select Role to login as"
          data={roles.map((role) => ({
            label: role.name,
            value: String(role.id),
            pass: role,
          }))}
          value={loginAs?.id ? String(loginAs.id) : null}
          onChange={(pass) => handleRoleChange(pass)}
        />

        <Menu>
          <Menu.Target>
            <div
              onClick={() => setOpened(!opened)}
              className="flex items-center cursor-pointer"
            >
              {userData.picture?.length ? (
                <Avatar size="md" src={userData.picture} radius="xl" />
              ) : (
                <Avatar size="md" radius="xl">
                  {userData.name[0].toUpperCase()}
                </Avatar>
              )}
              <div className="ml-2 flex flex-col justify-center">
                <Text size="md" style={{ lineHeight: 1.2 }}>
                  {userData.name}
                </Text>
                <Text size="xs" color="dimmed">
                  {userData.email}
                </Text>
              </div>
            </div>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item
              onClick={() =>
                (window.location.href = `${constants.chooseManager}`)
              }
              icon={<Exchange size={14} />}
            >
              choose manager
            </Menu.Item>
            <Menu.Item onClick={logoutHandler} icon={<DoorExit size={14} />}>
              Logout
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </div>
    </div>
  );
};

export default AppHeader;
